// libs
import styled from 'styled-components'
// icons
import EyeIconOrigin from '@mui/icons-material/VisibilityOff'
import EyeSelectedIconOrigin from '@mui/icons-material/Visibility'
// utils
import { size } from 'polished'

export const EyeIcon = styled(EyeIconOrigin)<{ color: string }>`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${({ color }) => color};
  }
`

export const EyeSelectedIcon = styled(EyeSelectedIconOrigin)<{ color: string }>`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${({ color }) => color};
  }
`
